export default "__VITE_ASSET__BDxewMNB__"